"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.swapWithFeeDiscountQuoteWithParams = exports.swapWithFeeDiscountQuoteByOutputToken = exports.swapWithFeeDiscountQuoteByInputToken = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const public_1 = require("../../utils/public");
const swap_utils_1 = require("../../utils/public/swap-utils");
const swap_quote_impl_1 = require("../swap/swap-quote-impl");
const web3_js_1 = require("@solana/web3.js");
/**
 * @category Quotes
 * @TODO additional function
 * @param whirlpool
 * @param inputTokenMint
 * @param tokenAmount
 * @param slippageTolerance
 * @param programId
 * @param fetcher
 * @param refresh
 * @returns
 */
function swapWithFeeDiscountQuoteByInputToken(whirlpool, discountToken, inputTokenMint, tokenAmount, slippageTolerance, programId, fetcher, refresh) {
    return __awaiter(this, void 0, void 0, function* () {
        const whirlpoolDiscountInfoPubkey = public_1.PDAUtil.getWhirlpoolDiscountInfo(new web3_js_1.PublicKey(programId), whirlpool.getAddress(), discountToken).publicKey;
        const whirlpoolDiscountInfoData = yield fetcher.getPoolDiscountInfo(whirlpoolDiscountInfoPubkey);
        if (!whirlpoolDiscountInfoData) {
            throw new Error("Whirlpool discount info does not exist");
        }
        const params = yield swapQuoteByToken(whirlpool, inputTokenMint, tokenAmount, true, programId, fetcher, refresh);
        return swapWithFeeDiscountQuoteWithParams(params, whirlpoolDiscountInfoData, slippageTolerance);
    });
}
exports.swapWithFeeDiscountQuoteByInputToken = swapWithFeeDiscountQuoteByInputToken;
function swapWithFeeDiscountQuoteByOutputToken(whirlpool, whirlpoolDiscountInfoData, outputTokenMint, tokenAmount, slippageTolerance, programId, fetcher, refresh) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = yield swapQuoteByToken(whirlpool, outputTokenMint, tokenAmount, false, programId, fetcher, refresh);
        return swapWithFeeDiscountQuoteWithParams(params, whirlpoolDiscountInfoData, slippageTolerance);
    });
}
exports.swapWithFeeDiscountQuoteByOutputToken = swapWithFeeDiscountQuoteByOutputToken;
/**
 * Get the token type of the input token for this swap quote.
 *
 * @category Quotes
 * @param quote - SwapQuote object
 * @returns the TokenType of the input token
 */
function swapWithFeeDiscountQuoteWithParams(params, whirlpoolDiscountInfoData, slippageTolerance) {
    const quote = (0, swap_quote_impl_1.simulateSwapWithFeeDiscount)(params, whirlpoolDiscountInfoData);
    const slippageAdjustedQuote = Object.assign(Object.assign({}, quote), swap_utils_1.SwapUtils.calculateSwapAmountsFromQuote(quote.amount, quote.estimatedAmountIn, quote.estimatedAmountOut, slippageTolerance, quote.amountSpecifiedIsInput));
    return slippageAdjustedQuote;
}
exports.swapWithFeeDiscountQuoteWithParams = swapWithFeeDiscountQuoteWithParams;
function swapQuoteByToken(whirlpool, inputTokenMint, tokenAmount, amountSpecifiedIsInput, programId, fetcher, refresh) {
    return __awaiter(this, void 0, void 0, function* () {
        const whirlpoolData = whirlpool.getData();
        const swapMintKey = common_sdk_1.AddressUtil.toPubKey(inputTokenMint);
        const swapTokenType = public_1.PoolUtil.getTokenType(whirlpoolData, swapMintKey);
        (0, tiny_invariant_1.default)(!!swapTokenType, "swapTokenMint does not match any tokens on this pool");
        const aToB = swap_utils_1.SwapUtils.getSwapDirection(whirlpoolData, swapMintKey, amountSpecifiedIsInput) ===
            public_1.SwapDirection.AtoB;
        const tickArrays = yield swap_utils_1.SwapUtils.getTickArrays(whirlpoolData.tickCurrentIndex, whirlpoolData.tickSpacing, aToB, common_sdk_1.AddressUtil.toPubKey(programId), whirlpool.getAddress(), fetcher, refresh);
        return {
            whirlpoolData,
            tokenAmount,
            aToB,
            amountSpecifiedIsInput,
            sqrtPriceLimit: swap_utils_1.SwapUtils.getDefaultSqrtPriceLimit(aToB),
            otherAmountThreshold: swap_utils_1.SwapUtils.getDefaultOtherAmountThreshold(amountSpecifiedIsInput),
            tickArrays,
        };
    });
}
